export default __webpack_public_path__ + "static/media/kleiton.1b6e9289.JPG";